<button class="ui-btn borderless-btn back-btn" (click)="paymentIframeExitModal.open()">
  <fa-icon [icon]="faChevronLeft"></fa-icon>
  Retour
</button>

<h1>Finaliser mon paiement</h1>

<div id="payment-pannel">
  <iframe id="payment-iframe" data-testid="payment-iframe" class="IframePaymentCard" frameborder="0" [src]="iframeUrl"
    (load)="onIframeLoad()">
  </iframe>
  <div id="logos">
    <div id="logos-line">
      <img id="credit-du-nord" src="assets/images/CDN.jpg" alt="credit du nord">
    </div>
  </div>
</div>

<ngx-smart-modal #paymentIframeExitModal identifier="paymentIframeExitModal" customClass="nsm-centered">
  <div class="modal-header">
    <h2>Quitter le paiement ?</h2>
  </div>
  <div class="modal-content">
    <div *ngIf="isClickSendOgone">
      <p>En quittant la page, vous devrez patienter 30 min le temps que le paiement de cette facture soit à nouveau
        disponible.</p>
    </div>
    <div *ngIf="!isClickSendOgone">
      <p>En quittant la page, votre sélection de factures/avoirs sera perdue.</p>
    </div>
  </div>
  <div class="modal-footer">
    <button class="ui-btn secondary-btn" (click)="paymentIframeExitModal.close()">Non</button>
    <button class="ui-btn primary-btn" (click)="onPaymentExitConfirmed()">Oui, quitter</button>
  </div>
</ngx-smart-modal>
